import { greatJobVideoAssetList } from 'src/components/PhoneAnimations/GreatJobVideo/assets.ts';
import { homeWorkoutImageList } from 'src/components/PhoneAnimations/HomeWorkout/assets.ts';
import { lateralRaiseAssetList } from 'src/components/PhoneAnimations/LateralRaise/assets.ts';
import { lateralRaiseCompleteAssetList } from 'src/components/PhoneAnimations/LateralRaiseComplete/assets.ts';
import { lateralRaiseDetailsAssetList } from 'src/components/PhoneAnimations/LateralRaiseDetails/assets.ts';
import { lateralRaiseHexRevealAssetList } from 'src/components/PhoneAnimations/LateralRaiseHexReveal/assets.ts';
import { lungesAssetList } from 'src/components/PhoneAnimations/Lunges/assets.ts';
import { lungesCompleteAssetList } from 'src/components/PhoneAnimations/LungesComplete/assets.ts';
import { lungesDetailsAssetList } from 'src/components/PhoneAnimations/LungesDetails/assets.ts';
import { lungesHexRevealAssetList } from 'src/components/PhoneAnimations/LungesHexReveal/assets.ts';
import { myProgressAssetList } from 'src/components/PhoneAnimations/MyProgress/assets.ts';
import { sideLungesAssetList } from 'src/components/PhoneAnimations/SideLunges/assets.ts';
import { trainerProfileAssetList } from 'src/components/PhoneAnimations/TrainerProfile/assets.ts';
import { trainersAssetList } from 'src/components/PhoneAnimations/Trainers/assets.ts';
import { trainingProgrammeAssetList } from 'src/components/PhoneAnimations/TrainingProgramme/assets.ts';
import { workoutResultsImageList } from 'src/components/PhoneAnimations/WorkoutResults/assets.ts';

export const ALL_ASSETS = [
  ...greatJobVideoAssetList,
  ...homeWorkoutImageList,
  ...lateralRaiseAssetList,
  ...lateralRaiseCompleteAssetList,
  ...lateralRaiseDetailsAssetList,
  ...lateralRaiseHexRevealAssetList,
  ...lungesAssetList,
  ...lungesCompleteAssetList,
  ...lungesDetailsAssetList,
  ...lungesHexRevealAssetList,
  ...myProgressAssetList,
  ...sideLungesAssetList,
  ...trainerProfileAssetList,
  ...trainersAssetList,
  ...trainingProgrammeAssetList,
  ...workoutResultsImageList,
] as const;
